import { Injectable } from "@angular/core";
import { ApiService } from "../../api.service";
import { Observable } from "rxjs";
import {
  ClientVMSSubInfo,
  TalentErnstAndYoungEmploymentHistory,
  TalentVmsEmploymentHistory,
  TalentVmsPreviousAnswers,
  TalentVmsRelationshipDisclosure,
  TalentVMSSubInfo
} from '../../../typings';

@Injectable({
  providedIn: 'root'
})
export class VmsSubmittalApiService {
  readonly baseURL = '/api/vms-submittal';

  constructor(private apiService: ApiService) {
  }

  getClientVMSSubInfo(orderId: Number) : Observable<ClientVMSSubInfo> {
    return this.apiService.httpWrapper<any>({
      method: 'GET',
      url: `${this.baseURL}/client/${orderId}`,
      authenticated: true
    })
  }

  getTalentVMSSubInfo(orderId: Number, talentId: Number): Observable<TalentVMSSubInfo> {
    return this.apiService.httpWrapper<TalentVMSSubInfo>({
      method: 'GET',
      url: `${this.baseURL}/talent/${orderId}/${talentId}`,
      authenticated: true
    })
  }

  saveTalentVMSSubInfo(talentVMSSubInfo: TalentVMSSubInfo): Observable<number> {
    return this.apiService.httpWrapper<number>({
      method: 'POST',
      url: `${this.baseURL}/talent`,
      body: talentVMSSubInfo
    });
  }

  saveTalentValidationInfo(talentVMSSubInfo: TalentVMSSubInfo): Observable<number> {
    return this.apiService.httpWrapper<number>({
      method: 'POST',
      url: `${this.baseURL}/talent-validation`,
      body: talentVMSSubInfo
    });
  }

  readVmsEmploymentHistoryCompleted(orderId: number, personId: number): Observable<boolean> {
    return this.apiService.httpWrapper<boolean>({
      method: 'GET',
      url: `${this.baseURL}/talent-employment-history-completed/${orderId}/${personId}`,
      authenticated: true
    })
  }

  readVmsRelationshipDisclosureCompleted(orderId: number, personId: number): Observable<boolean> {
    return this.apiService.httpWrapper<boolean>({
      method: 'GET',
      url: `${this.baseURL}/talent-relationship-disclosure-completed/${orderId}/${personId}`,
      authenticated: true
    })
  }

  readErnstAndYoungHistoryCompleted(orderId: number, personId: number): Observable<boolean> {
    return this.apiService.httpWrapper<boolean>({
      method: 'GET',
      url: `${this.baseURL}/talent-ernst-and-young-history-completed/${orderId}/${personId}`,
      authenticated: true
    })
  }

  readPreviousVmsAnswers(orderId: number, personId: number, gatherToken?: string): Observable<TalentVmsPreviousAnswers> {
    const tokenQuery = gatherToken ? `?gatherToken=${encodeURIComponent(gatherToken)}` : '';
    return this.apiService.httpWrapper<TalentVmsPreviousAnswers>({
      method: 'GET',
      url: `${this.baseURL}/talent-previous-answers/${orderId}/${personId}${tokenQuery}`,
      authenticated: true
    })
  }

  saveTalentVmsEmploymentHistoryAndRelationship(talentVmsFullEmploymentHistory: TalentVmsEmploymentHistory[],
                                                talentVmsRelationshipDisclosure: TalentVmsRelationshipDisclosure,
                                                talentErnstAndYoungEmploymentHistory: TalentErnstAndYoungEmploymentHistory): Observable<number> {
    return this.apiService.httpWrapper<number>({
      method: 'POST',
      url: `${this.baseURL}/talent-employment-history-and-relationship`,
      body: { talentVmsFullEmploymentHistory, talentVmsRelationshipDisclosure, talentErnstAndYoungEmploymentHistory}
    });
  }

  createActivity(activityTypeId: number, personId: number, orderId: number, jobPostingId: number) {
    return this.apiService.httpWrapper<any>({
      method: 'POST',
      url: `${this.baseURL}/activity`,
      body: {
        activityTypeId: activityTypeId,
        personId: personId,
        orderId: orderId,
        jobPostingId: jobPostingId
      }
    });
  }
}
